import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import { Indianlanguages } from "../assets/Json/laanlist";
import { AppContext } from "../context";
import Sample from "../assets/images/Dharmendra-Pradhan.png";
import Sample_translated from "../assets/images/Sample_translated_1.jpg";
import Instrctions from "./CommoComponent/Instructions";
import CorouselExample from "./imageCorousel";

function ImageUploadOCR() {
  const navigate = useNavigate();
  const [files, SetFiles] = useState();
  const [lang, SetLang] = useState();
  const [steps, SetSteps] = useState(false);
  const { data, setData } = useContext(AppContext);
  const fileTypes = ["JPG", "PNG", "JPEG"];

  const handleChange = async (file) => {
    let filesize = file.size;
    if (filesize > 2097152) {
      alert("file size too big");
      SetFiles();
    } else {
      SetFiles(file);
    }
  };
  const handleError = () => {
    alert("file size too big please upload image less than 2MB");
  };

  const selectlang = (value) => {
    let postData = { lang: value, file: files };
    setData(postData);
    SetLang(value);
    navigate("/JaduiDarpan/ImageOCR");
  };

  const handleProceed = () => {
    if (files) {
      SetSteps(true);
    } else {
      alert("Please upload Image");
    }
  };

  return (
    <>
      <div className="banner-allpage-sec">
        <ul className="breadcrumb">
          <li>
            <a href="https://anuvadini.aicte-india.org/">Home</a>
          </li>
          <li>
            <Link to="/JaduiDarpan/">Anuvadini-Image23</Link>
          </li>
        </ul>
        <CorouselExample />
        <div className="banner-content-sec text-center">
          <br />
          <h1 className="first-head">JaduiDarpan</h1>

          <h3 className="second-head">
            Translate photos into 30+ Languages In Seconds, whether they are
            posters, brochures, screenshots, advertisements, product images
          </h3>
          <br />
        </div>
      </div>
      <section
        style={{ textAlign: "center", marginTop: -50, position: "relative" }}
      >
        <div className="page-container">
          <div
            style={{
              border: "#ccc 2px dotted",
              borderRadius: 10,
              background: "#fff",
              padding: 50,
              width: "100%",
              margin: "auto",
            }}
          >
            {steps === false ? (
              <>
                <div
                  className="chakra-heading"
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <FileUploader
                    className="file-uploader"
                    multiple={false}
                    name="file"
                    label="Upload or drop a file right here... "
                    types={fileTypes}
                    maxSize={2}
                    onSizeError={handleError}
                    handleChange={handleChange}
                  />
                </div>

                <div className="upload-btn-wrapper mt-4">
                  <button
                    className="button orange btn"
                    onClick={handleProceed}
                    style={{
                      fontSize: 26,
                      borderRadius: 10,
                      padding: "15px 30px",
                    }}
                  >
                    Proceed
                  </button>
                </div>
                <div className="txt-eg">
                  Supported file formats: Image JPEG,JPG,PNG & Max file size
                  2MB.
                </div>
              </>
            ) : (
              <>
                <section className="selectlang">
                  <div className="container">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-12 mx-auto text-center">
                          <h3>Select Destination Language to proceed</h3>
                          <div className="mb-0 languageList d-flex justify-content-center">
                            {Indianlanguages.map((language) => (
                              <li onClick={() => selectlang(language.value)}>
                                {language.name}
                              </li>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </>
            )}
          </div>
        </div>

        {/* 
        <section>
          <div class="page-container passportPhotoSection">
            <div class="features">
              <div class="margin">
                <h2>Features</h2>
                <div class="moveChunk marginBto">
                  <div class="margin">
                    <div class="row no-gutters justify-space-around align-items-center pb-5">
                      <div class="col-sm-12 col-md-6 col-12">
                        <div class="relative" style={{maxWidth:"28.125rem"}}>
                          <img src={Sample} alt="" width="450" class="clearImg" />
                        </div>
                      </div>
                      <div class="flexCenter col-sm-12 col-md-5 col-12">
                        <div class="description">
                          <p class="chunkTitle"></p>
                          <p class="chunkDescription">Upload any image with text to translate it into 30+ Languages. The given Image is an Example of Image prior to Translation</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="moveChunk marginBto">
                  <div class="margin">
                    <div class="row no-gutters justify-space-around align-items-center  pb-5">
                      <div class="flexCenter col-sm-12 col-md-5 col-12">
                        <div class="description">
                          <p class="chunkTitle"></p>
                          <p class="chunkDescription">Now, this is a image with the translated Text in given language,  which is properly placed in the original Text place</p>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-12">
                        <div class="relative" style={{maxWidth:"28.125rem"}}>
                          <img src={Sample_translated} alt="" width="450" height="260" class="clearImg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>       */}

        <div className="page-container">
          <div className="row">
            {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <div className="diffImg">
            <img src={img02} alt="image" width="100%"/>
            </div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 ">
            <div className="diffImg02">
            <img src={img03} alt="" width="100%"/>
            </div>
        </div> */}
            {/* <div className="col-12 col-sm-12 col-md-12 col-lg-12 ">
            <div className="diffImg03">
             <h3>Tanslated image from Englist to gujarati</h3> 
            <img src={img04} alt="" width="100%"/>
            </div>
        </div> */}
          </div>
        </div>
      </section>
      {/* <div className="page-container logo-maker-page">
        <h2 className="text-center">SMARTER. FASTER. EASIER.</h2>
        <br />
        <br />
        <br />
        <div className="row text-center sfe-sec">
          <div className="col-lg-4">
            <div className="box">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                focusable="false"
                className="chakra-icon css-wk6432"
                height="4em"
                width="4em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="32"
                  d="M83 384c-13-33-35-93.37-35-128C48 141.12 149.33 48 256 48s208 93.12 208 208c0 34.63-23 97-35 128"
                ></path>
                <path
                  fill="none"
                  strokeMiterlimit="10"
                  strokeWidth="32"
                  d="M108.39 270.13l-13.69 8h0c-30.23 17.7-31.7 72.41-3.38 122.2s75.87 75.81 106.1 58.12h0l13.69-8a16.16 16.16 0 005.78-21.87L130 276a15.74 15.74 0 00-21.61-5.87zm295.22 0l13.69 8h0c30.23 17.69 31.74 72.4 3.38 122.19s-75.87 75.81-106.1 58.12h0l-13.69-8a16.16 16.16 0 01-5.78-21.87L382 276a15.74 15.74 0 0121.61-5.87z"
                ></path>
              </svg>
              <h3>Online stereo enhancer</h3>
              <p>
                This tool allows you to create a 3D audio version of any song
                directly in your browser. 3D versions of songs are popular on
                YouTube and with this tool you can create that 3D effect without
                having to download any annoying software.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="box">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                focusable="false"
                className="chakra-icon css-wk6432"
                height="4em"
                width="4em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="none"
                  strokeMiterlimit="10"
                  strokeWidth="32"
                  d="M256 80a176 176 0 10176 176A176 176 0 00256 80z"
                ></path>
                <path
                  fill="none"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="28"
                  d="M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296"
                ></path>
                <circle cx="250" cy="348" r="20"></circle>
              </svg>
              <h3>How is it done?</h3>
              <p>
                This tool will add a very small delay to one channel which
                creates a small but noticeable effect. It creates the illusion
                that the song is playing live in front of you. This effect is
                only effective if you're listening with headphones.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="box">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                focusable="false"
                className="chakra-icon css-wk6432"
                height="4em"
                width="4em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="32"
                  d="M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"
                ></path>
              </svg>
              <h3>Example of usage</h3>
              <p>
                Here is a before and after example of a short audio file that
                has been processed using this tool.
              </p>
            </div>
          </div>
        </div>
      </div> */}
      <Instrctions />
    </>
  );
}

export default ImageUploadOCR;
